export default class GatewayParsingError extends Error {
}
//# sourceMappingURL=GatewayParsingError.js.map